import '@cognite/cogs-lab-v11/dist/cogs-lab.css';
import '@cognite/cogs.js-v11/dist/cogs.css';
import 'allotment/dist/style.css';

import { useContext } from 'react';

import { AppContext } from './app.context';
import { setupMetrics } from './features/metrics/setup-metrics';
import { setupSentry } from './features/sentry/setup-sentry';

setupMetrics();
setupSentry();

/**
 * App - Main application entry point
 *
 * Routing decision is made at the top level and explicit:
 * - <AppProviders> sets up providers (DM or Classic based on useShouldUseCdmMode kook)
 * - <AppRoutes> renders routes (CdmRoutes or Routes based on useShouldUseCdmMode hook)
 *
 */
export const App = () => {
  const { AppProviders, AppRoutes } = useContext(AppContext);

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
};
